export const dashboardsTxt = {
  DASHBOARDS_ARE_BEING_UPDATED: "Dashboards are being updated",
  NO_ALLOWED_TO_EDIT: {
    title: "You are unable to add content to this dashboard",
    subtitle: "This dashboard is public but not editable or customizable",
  },
  NO_DASHBOARDS: {
    title: "No dashboards available",
    subtitle: "Select an existing organization dashboard or create a new one",
  },
  CREATE_NEW: "Create new",
  SELECT_DASHBOARD: "Select dashboard",
};
